import { getMessages } from '../../../../../../../store/constants';

export const LABEL_MILESTONE = getMessages().getText('card_form_convert_milestone');
export const LABEL_CONVERT_TO_MILESTONE = getMessages().getText('card_form_convert_to_milestone_tooltip');
export const LABEL_CONVERT_FROM_MILESTONE = getMessages().getText('card_form_convert_from_milestone_tooltip');
export const MILESTONE_EPIC = getMessages().getText('card_form_milestone_epic');
